import gql from 'graphql-tag'

export default gql`
query getPrinterLocationsNames {
	cashAssist {
		getAppConfig {
			cashRegisterGlobal {
				printerLocations {
					dbIndex
					value
				}
			}
		}
	}
}`
